import styled from 'styled-components';
import { HEFFALUMP } from 'HubStyleTokens/colors';
import * as CanvasIdentifiers from 'automation-ui-flow-core/canvas/CanvasIdentifiers';
import * as GraphConstants from 'automation-ui-flow-core/canvas/graphConstants';
export const StyledSingleConnector = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledSingleConnector",
  componentId: "sc-125jdx2-0"
})(["position:relative;z-index:1;text-align:center;width:100%;height:", "px;.", "{position:relative;z-index:2;}"], GraphConstants.SINGLE_CONNECTOR_HEIGHT, CanvasIdentifiers.ADD_BUTTON_CONTAINER);
export const StyledBranchConnector = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledBranchConnector",
  componentId: "sc-125jdx2-1"
})(["position:relative;z-index:1;display:flex;justify-content:center;width:100%;height:", "px;.", "{position:relative;z-index:2;}"], GraphConstants.BRANCH_CONNECTOR_BOTTOM_HEIGHT, CanvasIdentifiers.ADD_BUTTON_CONTAINER);
export const StyledSingleConnectorButton = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledSingleConnectorButton",
  componentId: "sc-125jdx2-2"
})(["position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);"]);
export const StyledConnectorLine = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledConnectorLine",
  componentId: "sc-125jdx2-3"
})(["&::after{content:'';position:absolute;z-index:0;top:0;bottom:0;left:calc(50% - 1px);border-left:", "px solid ", ";border-right:", "px solid ", ";}"], ({
  edgeThickness
}) => edgeThickness / 2, ({
  color = HEFFALUMP
}) => color, ({
  edgeThickness
}) => edgeThickness / 2, ({
  color = HEFFALUMP
}) => color);
export const StyledBranchTopSection = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledBranchTopSection",
  componentId: "sc-125jdx2-4"
})(["&::after{width:calc(50% - ", "px);content:'';height:", "px;position:absolute;z-index:0;top:0;bottom:0;", " ", ";}"], ({
  nodeWidth
}) => nodeWidth / 2, GraphConstants.BRANCH_CONNECTOR_TOP_HEIGHT + 2, ({
  align,
  nodeWidth
}) => align === 'right' ? `right: ${nodeWidth / 2}px;` : `left: ${nodeWidth / 2}px;`, ({
  align,
  color = HEFFALUMP,
  edgeThickness
}) => align === 'right' ? `border-left: ${edgeThickness / 2}px solid ${color};` : `border-right: ${edgeThickness / 2}px solid ${color};`);
export const StyledTopConnectorLine = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledTopConnectorLine",
  componentId: "sc-125jdx2-5"
})(["height:", "px;&::after{content:'';position:absolute;z-index:0;top:", "px;border-bottom:", "px solid ", ";", " ", "}"], GraphConstants.BRANCH_CONNECTOR_TOP_HEIGHT, GraphConstants.BRANCH_CONNECTOR_TOP_HEIGHT, ({
  edgeThickness
}) => edgeThickness, ({
  color
}) => color, ({
  width
}) => {
  return `width: ${width}px;`;
}, ({
  left
}) => {
  return `left: ${left}px;`;
});
export const StyledSingleNode = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledSingleNode",
  componentId: "sc-125jdx2-6"
})(["display:flex;flex-direction:column;align-items:center;"]);
export const StyledBranchConnectorButton = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledBranchConnectorButton",
  componentId: "sc-125jdx2-7"
})(["position:absolute;margin-top:15px;top:94px;transform:translateY(-50%);"]);
export const StyledBranchLabelContainer = styled.div.withConfig({
  displayName: "ConnectorStyledComponents__StyledBranchLabelContainer",
  componentId: "sc-125jdx2-8"
})(["position:absolute;top:18px;z-index:10;"]);